import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { ConfigurationService } from './configuration.service';

@Injectable({ providedIn: 'root' })
export class AnnouncementService implements OnDestroy {
  private readonly announcement = new BehaviorSubject<{ id: string; message: string } | null>(null);
  readonly announcement$ = this.announcement.asObservable();
  private request?: Subscription;
  private dismissedId: string | null = null;

  private interval?: ReturnType<typeof setInterval>;
  private started = false;
  private lastCheckAt = 0;
  private readonly onVisible = () => {
    if (document.visibilityState === 'visible' && Date.now() - this.lastCheckAt > 1000) this.check();
  };

  start(): void {
    if (this.started) return;
    this.started = true;
    this.check();
    window.addEventListener('focus', this.onVisible);
    document.addEventListener('visibilitychange', this.onVisible);
    this.interval = setInterval(() => {
      if (document.visibilityState === 'visible') this.check();
    }, 5 * 60 * 1000);
  }

  constructor(private config: ConfigurationService) {
    try { this.dismissedId = sessionStorage.getItem('cc.dismissedAnnouncement'); } catch { }
  }

  check(): void {
    if (this.request && !this.request.closed) return;
    this.lastCheckAt = Date.now();
    this.request = this.config.getConfigByName('update-request').subscribe({
      next: (res: any) => {
        const record = res?.data;
        const data = record?.data;
        if (!data?.publish || typeof data.message !== 'string' || !data.message.trim()) {
          this.announcement.next(null);
          return;
        }
        const id = JSON.stringify([record.id, data.date, data.message]);
        this.announcement.next(id === this.dismissedId ? null : { id, message: data.message });
      },
      error: (error) => { if (error?.status === 404) this.announcement.next(null); },
    });
  }

  dismiss(): void {
    this.dismissedId = this.announcement.value?.id || null;
    try { if (this.dismissedId) sessionStorage.setItem('cc.dismissedAnnouncement', this.dismissedId); } catch { }
    this.announcement.next(null);
  }

  ngOnDestroy(): void {
    if (this.interval) clearInterval(this.interval);
    window.removeEventListener('focus', this.onVisible);
    document.removeEventListener('visibilitychange', this.onVisible);
    this.request?.unsubscribe();
    this.announcement.complete();
  }
}
